import { render } from "./Municipio.vue?vue&type=template&id=7388c011&scoped=true&ts=true"
import script from "./Municipio.vue?vue&type=script&lang=ts"
export * from "./Municipio.vue?vue&type=script&lang=ts"

import "./Municipio.vue?vue&type=style&index=0&id=7388c011&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7388c011"]])

export default __exports__